import type { ReactNode } from 'react';
import { Card } from '@paige/ui';
import { useFormat } from '@paige/format';
import { compare } from '../period/compare';
import { tileLabel, type PeriodChoice } from '../period/period';
import type { Today } from './today-types';

/**
 * The one number that matters, large: card money collected in the period, and where it came from the
 * period before. Paying companies beside it. Paying means card money received, never a package staff set.
 */
export function TodayHero({ today, choice }: { today: Today; choice: PeriodChoice }): ReactNode {
  const f = useFormat();
  const { money, period } = today;
  const collected = compare(money.collected, money.previousCollected, {
    days: period.days,
    format: f.money,
  });
  const paying = compare(money.paying, money.previousPaying, { days: period.days, format: f.int });
  return (
    <Card className="ad-thero">
      <span className="ad-thero__main">
        <span className="ad-thero__label">{tileLabel('Collected by card', choice, period)}</span>
        <strong className="ad-thero__value">{f.money(money.collected)}</strong>
        <span className="ad-thero__compare">
          <span className={`ad-tone--${collected.tone}`}>{collected.change}</span>{' '}
          {collected.before}
        </span>
      </span>
      <span className="ad-thero__side" title="Companies with card money received in the period.">
        <span className="ad-thero__label">{tileLabel('Paying companies', choice, period)}</span>
        <strong className="ad-thero__count">{f.int(money.paying)}</strong>
        <span className="ad-thero__compare">
          <span className={`ad-tone--${paying.tone}`}>{paying.change}</span> {paying.before}
        </span>
      </span>
    </Card>
  );
}
